"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Inset;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function Inset(_ref) {
  var space = _ref.space,
      horizontal = _ref.horizontal,
      vertical = _ref.vertical,
      top = _ref.top,
      right = _ref.right,
      bottom = _ref.bottom,
      left = _ref.left,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(StyledInset, {
    space: space,
    horizontal: horizontal,
    vertical: vertical,
    top: top,
    right: right,
    bottom: bottom,
    left: left
  }, children);
}

function getSpacingValue(spacingName) {
  return spacingName ? spacingName : "0rem";
}

var StyledInset = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n"])), function (_ref2) {
  var space = _ref2.space,
      horizontal = _ref2.horizontal,
      vertical = _ref2.vertical,
      top = _ref2.top,
      right = _ref2.right,
      bottom = _ref2.bottom,
      left = _ref2.left;
  return "\n  padding: ".concat(getSpacingValue(top || vertical || space), " ").concat(getSpacingValue(right || horizontal || space), "\n    ").concat(getSpacingValue(bottom || vertical || space), " ").concat(getSpacingValue(left || horizontal || space), ";\n");
});